import { apiRootUrl } from '../assets/constants';
import { showApiErrorAlert } from '../functions/api';

type NotificationType = {
    isReaded: boolean,
    link: string,
    message: string,
    notificationId: number,
    notificationTime: string,
    title: string,
};

// 通知一覧の取得
export const getNotifications = (roomId: number, userId: number): Promise<NotificationType[] | void> => {
    const api = apiRootUrl + "/notifications/" + roomId.toString() + "/" + userId.toString();
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "通知一覧の取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            return result.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

// 通知の既読化
export const setNotificationAsRead = (notificationId: number): Promise<string | void> => {
    const api = apiRootUrl + "/notifications/" + notificationId.toString();
    const options = {
        method: "PUT",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "通知の既読化");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 204) {
                throw new Error(result.status);
            }
            return "success";
        })
        .catch((error) => {
            console.log(error);
        });
};

// 通知の削除
export const deleteNotification = (notificationId: number, isReaded: boolean): Promise<string | void> => {
    const api = apiRootUrl + "/notifications/" + notificationId.toString() + "?isReaded=" + isReaded;
    const options = {
        method: "DELETE",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "通知の削除");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 204) {
                throw new Error(result.status);
            }
            // 成功処理
            return "success";
        })
        .catch((error) => {
            console.log(error);
        });
};

// 未読状態の取得
export const hasUnreadNotifications = (userId: number): Promise<boolean | void> => {
    const api = apiRootUrl + "/notifications/hasUnreadNotifications/" + userId.toString();
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "通知未読状態の取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            return result.data.hasUnreadNotifications;
        })
        .catch((error) => {
            console.log(error);
        });
};
